import ResourceList from "../../components/ResourceList";
import {ResourcePanel, ResourcePanelNote, ResourcePanelTitle, openInNewTab} from "../../components/ResourcePanel";
import {reachUrls} from "../../layout/menu-items";
import {STATUS_DISPLAY} from "../templates/templateDisplay";
import {useGetSnippetUsages} from "../../apis/requests/snippets/getSnippetUsages";

type Props = {snippetId?: number};

const SnippetUsagePanel = ({snippetId}: Props) => {
  const {data} = useGetSnippetUsages({id: snippetId ?? 0}, {enabled: Boolean(snippetId)});

  if (!snippetId) return null;

  const templates = data?.templates ?? [];
  const snippets = data?.snippets ?? [];

  return (
    <ResourcePanel>
      <ResourcePanelTitle>Used by templates</ResourcePanelTitle>
      {templates.length === 0 ? (
        <ResourcePanelNote>No template uses this snippet.</ResourcePanelNote>
      ) : (
        <ResourceList
          items={templates.map((template) => ({
            id: String(template.id),
            label: template.name,
            variant: STATUS_DISPLAY[template.status]?.variant,
            tooltip: [
              STATUS_DISPLAY[template.status]?.label,
              template.via_snippet ? `uses the "${template.via_snippet}" snippet` : null,
            ]
              .filter(Boolean)
              .join(" - "),
            onClick: () => openInNewTab(`${reachUrls.templates}/${template.id}`),
          }))}
        />
      )}

      {snippets.length > 0 && (
        <>
          <ResourcePanelTitle spaced>Used by snippets</ResourcePanelTitle>
          <ResourceList
            items={snippets.map((snippet) => ({
              id: String(snippet.id),
              label: snippet.name,
              onClick: () => openInNewTab(`${reachUrls.snippets}/${snippet.id}`),
            }))}
          />
        </>
      )}
    </ResourcePanel>
  );
};

export default SnippetUsagePanel;
